import { render } from "./extend.vue?vue&type=template&id=5a6d36d2&scoped=true"
import script from "./extend.vue?vue&type=script&lang=js"
export * from "./extend.vue?vue&type=script&lang=js"

import "./extend.vue?vue&type=style&index=0&id=5a6d36d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6d36d2"]])

export default __exports__